import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setQualityReportPayload } from "../../../app/woundReportSlice";
import { Tab as TabComponent } from "../../secondary";
import { Header } from "../../secondary/Header";
import { QualityReportData } from "./qualityReportData";
import style from "./qualityReportForm.module.scss";
import { useExternalUserRedirect } from "../../../hooks/useExternalUserRedirect";
import { QualityReportSearchForm } from "./qualityReportSearchForm";
import { PROGRESS_LABELS } from "./qualityReportConf";
import { QualityReportOverview } from "./qualityReportOverview";

export const QualityReportForm = () => {
  const dispatch = useDispatch();

  const qualityReportPayload = useSelector((state) => state.woundreport.qualityReportPayload);
  const overViewData = useSelector((state) => state.woundreport.qualityAssuranceOverViewData);
  const woundCountData = useSelector((state) => state.woundreport.qualityAssuranceCountData);

  const [tempPayload, setTempPayload] = useState("");
  const [selectedDivOption, setSelectedDivOption] = useState(qualityReportPayload?.section ?? "Image Capture");
  const [woundProgressValue, setWoundProgressValue] = useState(qualityReportPayload?.subsection ?? "Taken Timely");
  const [tabIndex, setTabIndex] = useState(qualityReportPayload?.tabIndex ? qualityReportPayload?.tabIndex : 0);

  useExternalUserRedirect();

  const createOnSelect = (optionKey) => (index) => {
    setTabIndex(index);
    dispatch(setQualityReportPayload({ ...qualityReportPayload, tabIndex: index }));

    const labels = PROGRESS_LABELS[optionKey].map((item) => item.label);
    const label = labels?.[index] ?? labels?.[0] ?? "";
    setWoundProgressValue(label);
  };

  const renderTabName = (label, count) => (
    <>
      {label} <span>{count ?? 0}</span>
    </>
  );

  const tabList = PROGRESS_LABELS[selectedDivOption]?.map(({ label, countKey }) => ({
    name: renderTabName(label, woundCountData?.[countKey]),
    content: <QualityReportData woundProgressValue={woundProgressValue} tempPayload={tempPayload} selectedDivOption={selectedDivOption} />,
    className: style.tab_none,
  }));

  const tabConfig = Object.keys(PROGRESS_LABELS).reduce((config, option) => {
    config[option] = {
      onSelect: createOnSelect(option),
      tabList: tabList,
    };
    return config;
  }, {});

  return (
    <>
      <div className="right_block">
        <Header reportHeading={"Quality Assurance"} />
        <div className={`col ${style.wound_dashboard} mt-0`}>
          <QualityReportSearchForm
            selectedDivOption={selectedDivOption}
            setSelectedDivOption={setSelectedDivOption}
            woundProgressValue={woundProgressValue}
            setWoundProgressValue={setWoundProgressValue}
            setTempPayload={setTempPayload}
            setTabIndex={setTabIndex}
          />
          {overViewData !== "" && woundCountData !== "" ? (
            <>
              <QualityReportOverview
                selectedDivOption={selectedDivOption}
                setSelectedDivOption={setSelectedDivOption}
                setTabIndex={setTabIndex}
                setWoundProgressValue={setWoundProgressValue}
                tempPayload={tempPayload}
              />
              <div>
                {selectedDivOption && tabConfig[selectedDivOption] && (
                  <TabComponent
                    onSelect={tabConfig[selectedDivOption].onSelect}
                    selectedIndex={tabIndex ?? 0}
                    tabList={tabConfig[selectedDivOption].tabList}
                    woundReportView={true}
                    workListView={true}
                  />
                )}
              </div>
            </>
          ) : (
            <div className={style.no_matching_result}>Oops there are no matching results, please update your filter</div>
          )}
        </div>
      </div>
    </>
  );
};
